<ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="medium" color="#fff" type="ball-spin-clockwise">
</ngx-spinner>
<app-loader></app-loader>
<div class="control-section">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise"></ngx-spinner>
    <!-- sample level element  -->
    <div class="col-lg-12 col-sm-12 col-md-12 center">
        Click/Touch the button to view the sample
    </div>
    <div class="col-lg-12 col-sm-12 col-md-12 center">
        <a class="e-btn" id="newTab" (click)="newTabClick()" target="_blank">Open in new Tab</a
    >
  </div>

  <!-- sample level element  -->
  <div id="wrapper">
    <div class="col-lg-12 col-sm-12 col-md-12" id="sidebar-section">
      <div class="col-lg-12 col-sm-12 col-md-12">
        <!--header-section  declaration -->
        <div class="header-section dock-menu" id="header">
          <ul class="header-list">
            <li
              id="hamburger"
              class="icon-menu icon list"
              (click)="openClick()"
            ></li>
            <!-- <input type="text" placeholder="Search..." class="search-icon list"> -->
            <img
              style="
                max-height: 45px;
                margin-left: 10px;
                margin-top: 3px;
                border-radius: 3px;
              "
              src="{{ companyLogo }}"
              alt=""
            />
            <li class="right-header list">
              <div class="horizontal-menu">
                <i class="icon-user icon"></i
                ><span>{{ profile?.displayName }}</span>
                <!-- Menu element declaration -->
                <ejs-menu
                  [items]="AccountMenuItem"
                  scssClass="dock-menu"
                  (select)="loadRoutingContent($event)"
                >
                </ejs-menu>
              </div>
            </li>
            <!-- <li class="right-header list support">Support</li>
                      <li class="right-header list tour">Tour</li> -->
          </ul>
        </div>
        <!--end of header-section  declaration -->
        <!-- sidebar element declaration -->
        <ejs-sidebar
          id="sidebar-menu"
          class="dock-menu"
          #sidebarMenuInstance
          [enableDock]="enableDock"
          [width]="width"
          [dockSize]="dockSize"
          [mediaQuery]="mediaQuery"
          [target]="target"
        >
          <div class="main-menu">
            <p class="main-menu-header"></p>
            <!-- Menu element declaration -->
            <ejs-menu
              [items]="menuItems"
              orientation="Vertical"
              cssClass="dock-menu"
              (select)="onMenuItemSelect($event)"
            ></ejs-menu>
          </div>
          <!-- <div class="action">
                      <p class="main-menu-header">ACTION</p>
                      <button class="e-btn action-btn" id="action-button">+ Button</button>
                  </div> -->
        </ejs-sidebar>
        <!-- end of sidebar element -->

        <!-- main-content declaration -->
        <div class="main-content" id="maintext">
          <div id="sidebarMenuContent" class="sidebar-menu-content">
            <!-- <app-scheduler></app-scheduler> -->
            <router-outlet></router-outlet>
          </div>
        </div>

        <!-- end of main-content -->
      </div>
    </div>
  </div>
</div>

<!-- <app-splash-screen></app-splash-screen> -->

<p-toast [baseZIndex]="5000" position="top-right" [preventOpenDuplicates]="true" [breakpoints]="constants.toasterResponsive.toaster"></p-toast>
